module.exports = __webpack_public_path__ + "static/media/minato_left1ab96a9fa7a4ee5ce008305418b912c2.webp";